import React, { useState, useContext, useEffect } from 'react'

import Button from '@material-ui/core/Button'
import Select from '@material-ui/core/Select'
import InputLabel from '@material-ui/core/InputLabel'
import { makeStyles } from '@material-ui/core/styles'
import FormControl from '@material-ui/core/FormControl'
import MenuItem from '@material-ui/core/MenuItem'
import TextField from '@material-ui/core/TextField'

import _firebaseContext from '../../contexts/firebaseContext'
import _appContext from '../../contexts/appContext'

import firebase, { db } from '../../utils/firebase'

const useStyles = makeStyles((theme) => ({
    formControl: {
        display: 'block',
    },
    formField: {
        width: 200,
    },
    formSubmit: {
        marginTop: theme.spacing(2),
    },
    pushFormWrapper: {
        marginTop: 15,
    },
}))

const allLanguages = 'allLanguages'

export default function PushCreate(props) {
    const firebaseContext = useContext(_firebaseContext)
    const appContext = useContext(_appContext)

    const [topic, setTopic] = useState('planets')
    const [title, setTitle] = useState('')
    const [body, setBody] = useState('')

    const [locale, setLocale] = useState(allLanguages)
    const [languageList, setlanguageList] = useState([])
    const getLanguagesList = () =>
        firebaseContext
            .getLanguages()
            .catch((e) => console.log('getLanguagesList: ', e))
    useEffect(() => {
        ;(() => {
            getLanguagesList().then((languages) =>
                setlanguageList([
                    { id: allLanguages, data: { represent: 'Все языки' } },
                    ...languages,
                ])
            )
        })()
    }, [])

    const classes = useStyles()

    const handleTopicChange = (event) => {
        setTopic(event.target.value)
    }
    const handleTitleChange = (event) => {
        setTitle(event.target.value)
    }
    const handleBodyChange = (event) => {
        setBody(event.target.value)
    }

    const topics = [
        { id: 'planets', label: 'Планеты' },
        { id: 'streams', label: 'Стримы' },
    ]

    const handlePush = (event) => {
        if (props.onSubmit !== undefined) {
            props.onSubmit()
        }

        const currentTopic = `/topics/${topic}`

        firebaseContext
            .sendPushMessage(
                currentTopic,
                title,
                body,
                {},
                locale === allLanguages ? undefined : locale
            )
            .then((result) => {
                if (result.data.error) {
                    appContext.snackbar.showSnackbarMsg(
                        `Произошла ошибка: ${result.message}`
                    )
                } else {
                    appContext.snackbar.showSnackbarMsg(`Сообщение отправлено`)
                }
            })

        // const key =
        //     'AAAAsIV8uu0:APA91bHoZkNZtS8tshzmZSbWEfwUHpAX0F_yrk5pDCfspnP6_erm9qRvdory8CPiuPDObKKtyTJ8bOFkkIH_UiyHJzixQDyO0Q0nSoXlj6EOG4mVEzl7rNb1Ocmt6sXLSYoSEUDjRlqJ'

        // const notification = {
        //     title: title,
        //     body,
        //     sound: 'default'
        //     // icon: 'firebase-logo.png', 🌍
        //     // click_action: 'https://www.youtube.com/watch?v=dQw4w9WgXcQ', // 😁
        // }

        // fetch('https://fcm.googleapis.com/fcm/send', {
        //     method: 'POST',
        //     headers: {
        //         Authorization: 'key=' + key,
        //         'Content-Type': 'application/json',
        //     },
        //     body: JSON.stringify({
        //         notification: notification,
        //         to: `/topics/${topic}`,
        //         data: props.data || {},
        //     }),
        // })
        //     .then(function (response) {
        //         console.log(response)

        //         if (
        //             props.data !== undefined &&
        //             typeof props.data.path === 'string'
        //         ) {
        //             db.doc(props.data.path).update({
        //                 lastPushDateTime: firebase.firestore.Timestamp.fromDate(
        //                     new Date()
        //                 ),
        //             })
        //         }
        //     })
        //     .catch(function (error) {
        //         console.error(error)
        //     })
    }

    return (
        <>
            <div className={classes.pushFormWrapper}>
                <FormControl className={classes.formControl}>
                    <InputLabel id="topic">Тип уведомления</InputLabel>
                    <Select
                        labelId="topic"
                        value={topic}
                        onChange={handleTopicChange}
                        className={classes.formField}
                    >
                        {topics.map((topic) => (
                            <MenuItem value={topic.id} key={topic.id}>
                                {topic.label}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
                <FormControl className={classes.formControl}>
                    <InputLabel id="language">Язык уведомления</InputLabel>
                    <Select
                        labelId="language"
                        value={locale}
                        onChange={(newValue) =>
                            setLocale(newValue.target.value)
                        }
                        className={classes.formField}
                    >
                        {languageList &&
                            languageList.map((language) => (
                                <MenuItem value={language.id} key={language.id}>
                                    {language.data.represent}
                                </MenuItem>
                            ))}
                    </Select>
                </FormControl>
                <FormControl className={classes.formControl}>
                    <TextField
                        fullWidth
                        label="Заголовок"
                        onChange={handleTitleChange}
                    />
                </FormControl>
                <FormControl className={classes.formControl}>
                    <TextField
                        fullWidth
                        label="Текст уведомления"
                        onChange={handleBodyChange}
                    />
                </FormControl>

                <Button
                    onClick={handlePush}
                    variant="contained"
                    color="primary"
                    className={classes.formSubmit}
                    disabled={title === '' || body === ''}
                >
                    Отправить push-уведомление
                </Button>
            </div>
        </>
    )
}
